const benefits = [
  {
    name: 'Noverde',
    label: 'NOVERDE',
    items: [
      { description: 'Dinheiro na conta em até 1 dia útil.' },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Simplic',
    label: 'SIMPLIC',
    items: [
      { description: 'As condições podem ser negociadas.' },
      { description: 'Dinheiro na conta em até 1 dia útil.' },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Rebel',
    label: 'REBEL',
    items: [
      {
        description:
          'É permitido apenas contas dos bancos, BB, Santander, Caixa, Bradesco, Itaú e Inter.',
      },
      {
        description:
          'A conta bancária deve ter no mínimo 90 dias de criação e com movimentações.',
      },
      {
        description:
          'Será necessário acesso ao internet banking para comprovar renda.',
      },
      { description: 'Dinheiro na conta em até 1 dia útil.' },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Portocred',
    label: 'PORTOCRED',
    items: [
      { description: 'Dinheiro na conta em 1 dia útil.' },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Creditas',
    label: 'CREDITAS',
    items: [
      {
        description: `Só serão aceitos carros de modelos a partir de ${new Date().getFullYear() - 15}`,
      },
      { description: 'Aceitam todos os bancos.' },
      { description: 'Forma de pagamento em boleto.' },
      { description: 'De 45 a 60 dias para pagar a primeira parcela.' },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Omni',
    label: 'OMNI',
    items: [
      { description: `Dinheiro na conta em até 1 dia útil.` },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'PicPay',
    label: 'PICPAY',
    items: [
      {
        description:
          'Ideal para aposentados, pensionistas, militares e servidores públicos.',
      },
      { description: 'Pouca documentação e processo rápido.' },
      { description: 'Dinheiro na conta em até 2 dias úteis.' },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Banco BV',
    label: 'BV',
    items: [
      {
        description:
          'Válido apenas para um veículo quitado, em bom estado de conservação, sem multas ou impostos atrasados e atestado por vistoria online credenciada pela BV.',
      },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Banco BV',
    label: 'BV_FGTS',
    items: [
      {
        description: `É necessário ter um saldo mínimo de R$300 disponível no FGTS.`,
      },
      {
        description: `Contratação 100% online.`,
      },
      {
        description: `A simulação é feita pelo WhatsApp.`,
      },
      {
        description: `Time de especialistas disponível em todas as etapas.`,
      },
      {
        description: `Dinheiro na conta em até 1 dia útil.`,
      },
    ],
  },
  {
    name: 'Credjet',
    label: 'CREDJET',
    items: [
      { description: 'Forma de pagamento em boleto e em débito automático' },
      { description: 'Liberado em até 48 horas úteis após a contratação.' },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Sim',
    label: 'EMPRESTIMO_SIM',
    items: [
      {
        description:
          'Todo procedimento é feito pelo aplicativo (iOS ou Android).',
      },
      { description: 'Análise das informações realizada em até 72 horas.' },
      { description: 'Dinheiro na conta em até 1 dia útil após a aprovação.' },
      {
        description:
          'Pagamento no carnê, boleto ou débito automático (apenas para Santander).',
      },
      { description: 'Até 45 dias pra começar a pagar' },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Banco do Brasil',
    label: 'BANCO_DO_BRASIL',
    items: [
      { description: 'Primeira parcela em até 59 dias.' },
      {
        description:
          'O valor solicitado será depositado na conta autenticada, sem a necessidade de informar o motivo do empréstimo e nem comprovar o uso.',
      },
      {
        description:
          'O pagamento das parcelas será realizado através de débito automático em conta.',
      },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Zema',
    label: 'ZEMA',
    items: [
      { description: 'Parcelamento em até 24x' },
      { description: 'Dinheiro na conta em até 1 dia útil' },
      {
        description:
          'Aceitamos os seguintes bancos: Itaú, Santander, Bradesco, Caixa, HSCB, Banco do Brasil, Sicoob e Crediara',
      },
      {
        description:
          'Bancos digitais só serão aceitos mediante o envio do extrato bancário dos últimos 90 dias.',
      },
      { description: 'O pagamento das parcelas é realizado via boleto' },
      { description: 'Para dúvidas e informações contate em 0800 95 6702' },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Provu',
    label: 'PROVU',
    items: [
      { description: 'O pagamento das parcelas será realizado via boleto.' },
      {
        description:
          'Para contratos assinados até as 13h de dias úteis, o dinheiro cai na conta no mesmo dia.',
      },
      {
        description: 'Carência de até 45 dias para o primeiro pagamento.',
      },
      {
        description: 'Pagamento via boleto bancário.',
      },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'SuperSim',
    label: 'SUPERSIM',
    items: [
      {
        description:
          'Para ter o valor aprovado será preciso comprovar renda através de autenticação de conta bancária ou envio de extrato bancário.',
      },
      {
        description: 'Dinheiro na conta em até 30 minutos.',
      },
      {
        description: `Ao continuar, você estará concordando que leu e aceitou os <a href="https://www.supersim.com.br/termos/condicoes/" target="_blank">termos de uso</a> da SuperSim.`,
      },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Loft',
    label: 'CREDIHOME',
    items: [
      {
        description: 'Contratação 100% online.',
      },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Iti - Itaú',
    label: 'ITAU',
  },
  {
    name: 'Crefaz',
    label: 'CREFAZ',
    items: [
      {
        description: 'Somente é válida a conta de luz como opção de pagamento.',
      },
      {
        description:
          'A conta de luz deve estar em nome da pessoa que solicita o empréstimo.',
      },
      {
        description: 'Contratação 100% online.',
      },
      { description: 'Oferta sujeita à análise de crédito.' },
    ],
  },
  {
    name: 'Ágil',
    label: 'AGIL',
    items: [
      {
        description: 'Não precisa comprovar renda.',
      },
      {
        description: 'Dinheiro na conta em até 1 dia útil.',
      },
    ],
  },
  {
    name: 'JBCred',
    label: 'JBCRED',
    items: [
      {
        description: 'Aceita negativados.',
      },
      {
        description: 'Até 30 dias para começar a pagar.',
      },
      {
        description: 'Dinheiro na conta em até 1 dia útil.',
      },
    ],
  },
  {
    name: 'Juvo',
    label: 'JUVO',
    items: [
      {
        description:
          'A Juvo não aceita como garantia os seguintes aparelhos: Positivo, Lenovo, A01, A02 e A03.',
      },
      {
        description: 'Aceita autônomos.',
      },
      {
        description: 'Não precisa comprovar renda.',
      },
      {
        description: 'Dinheiro na conta em até 1 dia útil.',
      },
    ],
  },
  {
    name: 'H Cred',
    label: 'HCRED',
    items: [
      {
        description: 'Compromete seu limite do cartão.',
      },
      {
        description: 'Suporte do atendimento em toda a contratação',
      },
      {
        description: 'Dinheiro na conta em até 30 minutos.',
      },
    ],
  },
  {
    name: 'Cronos',
    label: 'CRONOS',
    items: [
      {
        description: 'Saque seu limite do cartão via PIX.',
      },
      {
        description: 'Contratação 100% online, sem burocracia.',
      },
      {
        description: 'Dinheiro na conta em até 1 dia útil.',
      },
      {
        description:
          'Contratações feitas no fim de semana serão pagas por PIX no próximo dia útil.',
      },
    ],
  },
  {
    name: 'Up.p',
    label: 'UPP',
    items: [
      {
        description: 'Pagamento via PIX',
      },
      {
        description: 'Contratação 100% online.',
      },
      {
        description: 'Descontos anuais e sem boleto.',
      },
      {
        description: 'Dinheiro na conta em até 24 horas úteis.',
      },
    ],
  },
  {
    name: 'Blipay',
    label: 'BLIPAY',
    items: [
      {
        description:
          'Aceita pessoas com nome sujo, aposentadas, autônomas, entre outras.',
      },
      {
        description: 'Antecipação direta no salário.',
      },
      {
        description: 'Dinheiro imediato via Pix.',
      },
    ],
  },
  {
    name: 'Zippi',
    label: 'ZIPPI',
    items: [
      {
        description:
          'O crédito ideal para MEIs e autônomos, liberado direto pelo CPF, sem precisar de CNPJ.',
      },
      {
        description:
          'Seu nome precisa estar limpo, sem dívidas em aberto nos órgãos de proteção ao crédito.',
      },
      {
        description:
          'Crédito toda semana, na palma da sua mão. Pague em dia e veja seu limite aumentar!',
      },
    ],
  },
  {
    name: 'Segue Financeira',
    label: 'SEGUE',
    items: [
      {
        description: 'Pagamento via Pix.',
      },
      {
        description: 'Contratação 100% online.',
      },
      {
        description: 'Descontos anuais e sem boleto.',
      },
      {
        description: 'Dinheiro na conta em até 24 horas úteis.',
      },
    ],
  },
  {
    name: 'ZiliCred',
    label: 'ZILICRED',
    items: [
      { description: 'Você só paga pelo que usar da sua linha de crédito' },
      { description: 'Juros somente sobre valor sacado' },
      {
        description:
          'A cada pagamento, o seu limite é restabelecido automaticamente',
      },
    ],
  },
  {
    name: 'Koin',
    label: 'KOIN',
    items: [
      {
        description: 'Limite parcelado no PIX',
      },
      {
        description: 'Transação em menos de 1 minuto ',
      },
      {
        description: 'Contratação online via aplicativo',
      },
    ],
  },
  {
    name: 'DeuTop',
    label: 'DEUTOP',
    items: [
      {
        description: 'Jornada 100% online, simples e rápida.',
      },
      {
        description: 'Open Finance e sem documentos.',
      },
      {
        description: 'Empréstimo no PIX.',
      },
    ],
  },
]

export default benefits
